import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux";
import {
  useGeneralState,
  useSelf,
  useSelfWorkContracts,
} from "../../redux/general/selectors";
import { getCurrentEmployeeWorkContracts } from "../../redux/employees/profiles/contracts/workContract";
import { Role } from "../../redux/api-model/organization/company";

type ContractProfileLink = {
  link: string;
  reinvalidateLink: (updatedEmployeeId: string) => void;
};

export default function useContractProfileLink(): ContractProfileLink {
  const dispatch = useDispatch<AppDispatch>();
  const self = useSelf();
  const general = useGeneralState();
  const selfWorkContracts = useSelfWorkContracts();
  const employeeId = self.data.employeeId;
  const isLoadNeeded = selfWorkContracts.length === 0 && employeeId;
  const isSingleContract = selfWorkContracts.length === 1;
  const [contractId] = selfWorkContracts.map((contract) => contract.uuid);
  const employeeType = general.userSelection.type;
  const isWorkContractAccess = employeeType === Role.WORK_CONTRACT_ACCESS;

  function reinvalidateLink(updatedEmployeeId: string) {
    if (updatedEmployeeId === employeeId) {
      dispatch(getCurrentEmployeeWorkContracts(employeeId));
    }
  }

  const basicParams = { reinvalidateLink, link: "/app" };

  useEffect(() => {
    if (isLoadNeeded) {
      dispatch(getCurrentEmployeeWorkContracts(employeeId));
    }
  }, [isLoadNeeded, employeeId]);

  if (isSingleContract && isWorkContractAccess) {
    return { ...basicParams, link: `/app/me/contract/${contractId}` };
  }

  if (isWorkContractAccess) {
    return { ...basicParams, link: "/app/me/overview" };
  }

  if (isSingleContract) {
    return {
      ...basicParams,
      link: `/app/employees/${employeeId}/contract/${contractId}`,
    };
  }

  return basicParams;
}
